import { createField } from "./vessel.section";
import { createForm as createFormVessel } from "../../../vessel/vessel.logic";
import {
    callPreviewVesselRequestAttachment
} from "../../license/request-license.section";

export const initForm = ({ props, data, refs }) => {
    const key = props.itemsKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, isLoading });
    const promises = [callPreviewVesselRequestAttachment({})];
    return Promise.all(promises).then((arr) => {
        data.previewVesselRequestAttachment = arr[0];
    });
};

export const createForm = () => createFormVessel();
